export default __webpack_public_path__ + "static/media/139.02f1b570.jpg";